module.exports = __webpack_public_path__ + "static/media/SerendipityOne-Regular.608c09b0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SerendipityOne-Regular.ttf
// module id = 3413
// module chunks = 51